export const CHART_COLORS = [
    {
        solid: 'rgba(99, 195, 255)',
        transparent: 'rgba(99, 195, 255, 0.5)',
    }, {
        solid: 'rgb(255, 159, 99)',
        transparent: 'rgba(255, 159, 99, 0.5)',
    }, {
        solid: 'rgb(180, 99, 255)',
        transparent: 'rgba(180, 99, 255, 0.5)',
    }, {
        solid: 'rgb(255, 242, 99)',
        transparent: 'rgba(255, 242, 99, 0.5)',
    }, {
        solid: 'rgb(255, 99, 132)',
        transparent: 'rgba(255, 99, 132, 0.5)',
    }, {
        solid: '#cbefd9',
        transparent: 'rgba(128, 255, 99, 0.5)',
    }
];

export const NEGATIVE_CHART_COLORS = [
    {
        solid: 'rgb(255,99,99)',
        transparent: 'rgba(255,99,99, 0.5)',
    }
]

export const BLACKOUT_PERIODS_COLORS = [
    "rgb(141,212,255)",
    "#b386f7",
    "#f7b986",
    "#ec86f7",
    "#86aaf7",
    "#f78686",
    "#9ef786",
    "#d8cba2",
    "#f7a086",
    "#8699f7",
];